import { Either, Left, Right } from 'fp-ts/lib/Either'
import { Response } from 'superagent'

import { log } from '@/log'
import { ApiClientWithAuth } from '@/services/api/client'
import { ApiService } from '@/services/api/service'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import AppId from '@/util/appid'

const namespace: string = 'cart'

/**
 * TODO: spa, ajax双方にCartServiceが別れて存在してしまっているので、共通のCartServiceに集約する。
 * @see /client/src/models/api/cart/cart/README.md
 */
export class CartService extends ApiService {
  static createFromBrandEnglishName(brandEnglishName: string): CartService {
    return new CartService(AppId.getByBrandName(brandEnglishName))
  }

  constructor(
    protected readonly appId: string,
    private readonly apiClient: typeof ApiClientWithAuth = ApiClientWithAuth
  ) {
    super(appId)
  }

  get brandEnglishName(): string {
    return AppId.getBrandNameByAppId(this.appId)
  }

  async list(query: any = {}): Promise<Either<Error, object[]>> {
    try {
      const response = await this.apiClient
        .get(`/api/user-proxy/${this.appId}/commerce_user_cart`)
        .query({
          cart_status: 1,
          ...query,
        })

      log.debug({ service: `${namespace}/list`, response })

      return new Right(response.body.data)
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }

  /**
   * TODO: product_id MIGHT be unique key, so return single element
   * @param productId
   * @param option
   */
  async get(
    productId: string,
    option: { cart_status?: number } = {} // TODO define interface when amount of options is many.
  ): Promise<Either<Error, Response>> {
    try {
      const response = await this.apiClient
        .get(`/api/user-proxy/${this.appId}/commerce_user_cart`)
        .query({
          product_id: productId,
          ...option,
        })

      log.debug({ service: `${namespace}/get`, response })

      return new Right(response)
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }

  async post(param: PostParam | PostParam[]): Promise<Either<Error, Response>> {
    try {
      if (!Array.isArray(param)) {
        return this.post([param])
      }

      const items = param.map(p => ({
        product_id: p.productId,
        unitPrice: p.unitPrice,
        isPaidMembershipPrice: p.isPaidMembershipPrice,
        unitCount: p.unitCount,
      }))

      const response = await this.apiClient
        .postJson(`/api/user/cart/${this.brandEnglishName}`, { items })

      log.debug({ service: `${namespace}/post`, response })

      param.forEach((p) => {
        EventBusForThirdParty.getInstance().publish('add-to-cart', {
          skuId: p.productId,
          unitPrice: p.unitPrice,
          unitCount: p.unitCount,
        })
      })

      return new Right(response)
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }
}

interface PostParam {
  productId: string,
  unitPrice: number,
  isPaidMembershipPrice: boolean,
  unitCount: number,
}
